import { useEffect, useRef } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { useSelector } from "react-redux";

// React Query Client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      onError: (err) => {
        Promise.reject(err);
      },
    },
  },
});

const ReactQueryProvider: React.FC<{}> = ({ children }) => {
  const catalogueVersion = useSelector((state: any) => parseInt(state.global.data.catalogueVersion || 1));
  const lastCatalogueVersion = useRef<number | undefined>(undefined);
  useEffect(() => {
    if (lastCatalogueVersion.current && lastCatalogueVersion.current !== catalogueVersion)
      queryClient.invalidateQueries();
    lastCatalogueVersion.current = catalogueVersion;
  }, [catalogueVersion]);

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};

export default ReactQueryProvider;
